export const errorMsg = {
  fs: {
    1: 'File has been completely uploaded',
    15: 'No such file or directory',
    17: 'Upload failed, current Data Hub is full. Please expand or reduce usage.',
    54: 'File already exists',
  },
  [-6]: 'Too many operations, please try again later',
  1: 'Server internal error',
  2: 'Username or password incorrect, please retry', // 'User does not exist'
  3: 'Username or password incorrect, please retry', // 'Password incorrect'
  4: 'Account already registered',
  5: 'Verification code incorrect, please retry',
  6: 'Service exception, please try again later or contact our assistant for help',
  7: 'Insufficient privileges to access',
  8: 'Password does not meet the rules: requires 8-20 characters and no Chinese characters',
  17: 'disk quota exceeded',
  20: 'Machine status exception, please refresh the page and try again.',
  23: 'Verification code sent too frequently, please try again later',
  24: 'Phone number blocked by operator, please contact our assistant for help',
  28: 'Account abnormality, please contact our assistant for help',
  39: 'Activity has expired',
  40: 'You have already participated in this activity. Please check the rewards center.',
  41: 'Voucher has been redeemed',
  46: 'Insufficient balance, please recharge and try again',
  47: 'You have already submitted your student verification. Please do not submit again',
  49: 'Your application has been approved',
  51: 'Your privileges are restricted and you cannot access this page',
  53: 'Sorry, there are not enough machines available',
  55: 'You have no operation permission',
  57: 'Sorry, the machine is occupied by another user',
  59: 'New and old passwords cannot be the same. Please modify and try again.',
  78: 'Environment save operation has been completed. You cannot modify or cancel it.',
  80: 'Edu verify failed',
  82: 'You can only enjoy one student package per month. Welcome to purchase next month.',
  83: 'Inventory is insufficient. If you need help, please contact our assistant.',
  88: 'The number of machines in the current cluster has reached its maximum limit.',
  90: 'Machine status abnormal. Please refresh and try again.',
  94: 'The environment used to start the machine has been deleted. You cannot continue saving it.',
  107: 'The email you entered is already occupied by another account. If you need help, please contact our assistant.',
  114: 'The current system does not support saving an unpublic image as a team environment, and also does not support saving a team environment as a personal environment or other team environment',
  122: 'The information you entered may contain incorrect information. Please modify it and try again. If you have any questions, please contact our assistant.',
  133: 'The network group name already exists',
  148: 'Environment save failed: The environment depends on the base image of the course or group, which is not available to non-members',
  149: 'The dependent course or group image no longer exists. You cannot save the environment.',
  155: 'Operation failed: The group does not exist',
  156: 'Operation failed. Please remove all machines before deleting a group',
  157: 'Cluster creation failed. Please contact our assistant to check detailed reasons',
  158: 'Cluster upgrade failed. Please contact our assistant to check detailed reasons',
  159: 'Operation failed. Do not repeat the operation in a short time.',
  160: 'Operation failed. Do not repeat the operation in a short time.',
  161: 'Operation failed. The node status is abnormal. Please try again later.',
  164: 'Instance quota insufficient. If you need more, please contact our assistant.',
  167: 'Currently, virtual machines cannot be added to a deep learning cluster',
  170: 'Addition failed. There are unsupported instance types (e.g., instances that support Docker) in the selected instances',
  171: 'The node is currently a package instance. You cannot manually release it.',
  177: 'Lack of resume times',
  186: 'The network group is not empty',
  187: 'The network group does not exist',
  194: 'Port has already in use',
}

export const ignoreErrorCodes = [80, 194]
